export function initJourney(){
    const journey = document.querySelector<HTMLElement>('.journey-items');
    const lineBg = document.querySelector<HTMLElement>('.journey-items-line-bg');

    if (journey && lineBg) {
        const updateLine = () => {
            const rect = journey.getBoundingClientRect();
            const windowHeight = window.innerHeight;

            const totalHeight = journey.offsetHeight;

            // 👇 точка отсчёта — середина экрана
            const triggerPoint = windowHeight / 2.5;

            const scrolled = Math.min(
                totalHeight,
                Math.max(0, triggerPoint - rect.top)
            );

            const progress = scrolled / totalHeight;

            lineBg.style.height = `${progress * 100}%`;
        };

        let ticking = false;

        const onScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    updateLine();
                    ticking = false;
                });
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);
        window.addEventListener('resize', updateLine);

        updateLine();
    }

}